import * as types from '../common/types'
import createReducer from './createReducer'

const initialState = {}

export const todos = createReducer(initialState, {
  [types.SET_DAILY_TODOS](state, { todos }) {
    let newState = { ...state }
    newState.today = todos
    return newState
  },
  [types.CLEAR_TODOS]() {
    return initialState
  },
  [types.SET_CURRENT_DATE](state, { date }) {
    let newState = { ...state }
    newState.currentDate = date
    return newState
  },
  [types.SET_RECURRING_TODOS](state, { recurringTodos }) {
    let newState = { ...state }
    newState.recurring = recurringTodos
    return newState
  },
})
